import React, { useState, useEffect } from 'react';
import { adminService } from '../services/adminService.js';
import toast from 'react-hot-toast';

function Plans() {
  const [plans, setPlans] = useState([]);
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, content: '' });
  const [hovered, setHovered] = useState(null);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20, totalPages: 0 });
  const [filters, setFilters] = useState({ planId: 'all', status: '', page: 1 });
  const [showStats, setShowStats] = useState(true);

  useEffect(() => {
    loadData();
  }, [filters.page, filters.planId, filters.status]);

  const loadData = async () => {
    try {
      setLoading(true);
      setStatsLoading(true);
      const params = { page: filters.page, limit: 20 };
      if (filters.planId && filters.planId !== 'all') params.planId = filters.planId;
      if (filters.status) params.status = filters.status;

      const [plansResult, statsResult] = await Promise.all([
        adminService.getPlans(params),
        adminService.getPlansStats(),
      ]);
      setPlans(plansResult.plans || []);
      setPagination(plansResult.pagination || { total: 0, page: 1, limit: 20, totalPages: 0 });
      setStats(statsResult);
    } catch (err) {
      toast.error('Erro ao carregar planos');
    } finally {
      setLoading(false);
      setStatsLoading(false);
    }
  };

  const formatMonth = (m) => {
    try {
      if (!m) return '';
      const iso = (typeof m === 'string' && m.includes('-')) ? `${m}-01` : m;
      const d = new Date(iso);
      if (isNaN(d)) return m;
      const monthsPt = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      const mon = monthsPt[d.getMonth()] || d.toLocaleString('pt-BR', { month: 'short' });
      const year = d.getFullYear();
      return `${mon} ${year}`;
    } catch (e) {
      return m;
    }
  };

  const getPlatformBadge = (raw) => {
    const val = (raw || '').toString().toLowerCase();
    const map = {
      apple: { label: 'Apple', class: 'badge-apple' },
      google: { label: 'Google', class: 'badge-google' },
      stripe: { label: 'Stripe', class: 'badge-stripe' },
      local: { label: 'Local', class: 'badge-local' },
      other: { label: 'Outro', class: 'badge-other' },
    };
    return map[val] || { label: (raw || 'Outro'), class: 'badge-other' };
  };

  return (
    <div className="admin-page">
      {/* Stats */}
      {showStats && (
        statsLoading ? (
          <div className="stats-grid stats-grid-4">
            {[1, 2, 3, 4].map(i => <div key={i} className="shimmer shimmer-card"></div>)}
          </div>
        ) : (
          stats && (
            <div className="stats-grid stats-grid-4">
              <div className="stat-card">
                <div className="stat-card-content">
                  <div className="stat-card-info">
                    <span className="stat-label">Total de Planos</span>
                    <span className="stat-value">{stats.totalPlans || 0}</span>
                  </div>
                  <div className="stat-icon" style={{ background: '#7165FF15' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7165FF" strokeWidth="2"><path d="M12 2v20M2 12h20" /></svg>
                  </div>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-card-content">
                  <div className="stat-card-info">
                    <span className="stat-label">Planos Ativos</span>
                    <span className="stat-value">{stats.totalActivePlans || 0}</span>
                  </div>
                  <div className="stat-icon" style={{ background: '#7165FF15' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7165FF" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
                  </div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-card-content">
                  <div className="stat-card-info">
                    <span className="stat-label">Planos no Mês</span>
                    <span className="stat-value">{stats.currentMonthPlans || 0}</span>
                  </div>
                  <div className="stat-icon" style={{ background: '#7165FF15' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7165FF" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                  </div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-card-content">
                  <div className="stat-card-info">
                    <span className="stat-label">Ganhos estimados</span>
                    <span className="stat-value">{stats.netMonthlyRevenue?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || 'R$ 0,00'}</span>
                  </div>
                  <div className="stat-icon" style={{ background: '#7165FF15' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7165FF" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
                  </div>
                </div>
              </div>
              {/* <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-card-info">
                <span className="stat-label">Taxa de Churn</span>
                <span className="stat-value">{stats.churnRate || '0%'}</span>
              </div>
              <div className="stat-icon" style={{ background: '#DC262615' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>
              </div>
            </div>
          </div> */}
            </div>
          )
        )
      )}

      {/* Filters */}
      <div className="admin-filters">
        <div className="filter-group">
          <select value={filters.planId} onChange={(e) => setFilters(f => ({ ...f, planId: e.target.value, page: 1 }))} className="filter-control">
            <option value="all">Todos os Planos</option>
            <option value="basic">Básico</option>
            <option value="premium">Premium</option>
          </select>
          <select value={filters.status} onChange={(e) => setFilters(f => ({ ...f, status: e.target.value, page: 1 }))} className="filter-control">
            <option value="">Todos os Status</option>
            <option value="active">Ativos</option>
            <option value="inactive">Inativos</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="admin-table-card">
        <div className="table-header">
          <h3>Assinaturas ({pagination.total})</h3>
        </div>
        {loading ? (
          <div className="table-loading">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className="shimmer shimmer-row"></div>)}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Negócio</th>
                  <th>Plano</th>
                  <th>Status</th>
                  <th>Plataforma</th>
                  <th>Data de Criação</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {plans.length === 0 ? (
                  <tr><td colSpan="6" className="empty-table">Nenhum plano encontrado</td></tr>
                ) : plans.map((plan, i) => {
                  const planKey = (plan.plan || plan.planId || '').toString().toLowerCase();
                  // Determine price by plan
                  const priceByPlan = (() => {
                    if (planKey.includes('plus') || planKey.includes('plus')) return 79.9;
                    if (planKey.includes('premium') || planKey.includes('premium')) return 129.9;
                    if (planKey.includes('free') || planKey.includes('free')) return 0.0;
                    return 39.9;
                  })();

                  const displayPrice = plan.price != null ? plan.price : priceByPlan;

                  const isPremium = planKey.includes('premium');

                  return (
                    <tr key={plan.id || i}>
                      <td className="td-name">{plan.entityName || plan.Entity?.name || plan.entity?.name || '-'}</td>
                      <td><span className={`badge ${isPremium ? 'badge-premium' : 'badge-default'}`}>{plan.plan || plan.planId || plan.name}</span></td>
                      <td>
                        <span className={`badge ${plan.active ? 'badge-success' : 'badge-danger'}`}>
                          {plan.active ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>
                      <td>
                        {(() => {
                          const platformRaw = plan.platform || plan.paymentProvider || plan.provider || plan.gateway || plan.purchasePlatform || plan.payment_method || plan.paymentMethod || 'other';
                          const badge = getPlatformBadge(platformRaw);
                          return <span className={`badge ${badge.class}`}>{badge.label}</span>;
                        })()}
                      </td>
                      <td>{plan.createdAt ? new Date(plan.createdAt).toLocaleDateString('pt-BR') : '-'}</td>
                      <td>R$ {Number(displayPrice).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {pagination.totalPages > 1 && (
          <div className="table-pagination">
            <button className="btn btn-sm" disabled={filters.page === 1} onClick={() => setFilters(f => ({ ...f, page: f.page - 1 }))}>Anterior</button>
            <span className="pagination-info">Página {pagination.page} de {pagination.totalPages}</span>
            <button className="btn btn-sm" disabled={filters.page >= pagination.totalPages} onClick={() => setFilters(f => ({ ...f, page: f.page + 1 }))}>Próxima</button>
          </div>
        )}
      </div>

      {/* Revenue Chart */}
      {stats?.revenueByMonth && stats.revenueByMonth.length > 0 && (
        <div className="charts-grid">
          <div className="chart-card chart-full">
            <div className="chart-header"><h3>Planos por Mês</h3></div>
            <div className="chart-body">
              <div className="simple-chart">
                {stats.revenueByMonth.map((item, i) => (
                  <div key={i} className="chart-bar-group" onMouseEnter={(e) => { setHovered(i); setTooltip({ visible: true, x: e.clientX + 12, y: e.clientY + 12, content: `${item.plansCount || 0} planos` }); }} onMouseMove={(e) => setTooltip(t => ({ ...t, x: e.clientX + 12, y: e.clientY + 12 }))} onMouseLeave={() => { setHovered(null); setTooltip({ visible: false, x: 0, y: 0, content: '' }); }} style={{ opacity: hovered === null || hovered === i ? 1 : 0.28 }}>
                    <div className="chart-bar" style={{ height: `${Math.max(((item.plansCount || 0) / Math.max(...stats.revenueByMonth.map(r => r.plansCount || 0), 1)) * 200, 4)}px`, background: 'var(--chart-green)' }}></div>
                    <span className="chart-bar-label">{formatMonth(item.month)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {tooltip.visible && (
        <div className="cursor-tooltip" style={{ left: tooltip.x + 'px', top: tooltip.y + 'px' }}>{tooltip.content}</div>
      )}
    </div>
  );
}

export default Plans;
